<!--header-right-->
<template>
  <div class="home-business-card-add">
    <div class="icon" :style="{backgroundImage: `url(${require('@/assets/image/base/add/icons_24pt_add_black.svg')})`}"></div>
    {{$t('AddFlight')}}
  </div>
</template>
<script type="text/ecmascript-6">
export default {
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
/** 超标支付样式  */
.home-business-card-add
  @extend .flex-center
  @extend .hs-font-subtitle-big
  width 100%
  min-height 46px
  color $color_black_800
  border 1px solid $color_black_40
  padding 10px 16px
  border-radius 8px
  >.icon
    width 24px
    height 24px
    background-size 100% 100%
    background-repeat no-repeat
    margin-right 8px
    color $color_black_800
</style>
